import React from "react";

export const ErrorPopup = ({ error, onClose, show = false }) => {
  if (!error || !show) return null;

  return (
    <div className="ErrorPopup-overlay" onClick={onClose}>
      <div className="ErrorPopup" role="alert" onClick={(e) => e.stopPropagation()}>
        <div className="ErrorPopup-content">
          <div className="ErrorPopup-header">
            <h3>Payment Error</h3>
            <button
              className="ErrorPopup-close"
              onClick={onClose}
              aria-label="Close"
            >
              ×
            </button>
          </div>
          <div className="ErrorPopup-body">
            <p className="ErrorPopup-message">{error.message}</p>
            {error.detail && (
              <p className="ErrorPopup-detail">{error.detail}</p>
            )}
          </div>
          <div className="ErrorPopup-footer">
            <button className="ErrorPopup-button" onClick={onClose}>
              Close
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};
